export default "__VITE_ASSET__C3jefF6V__"